export const pageNames = {
    engagements: "Engagements Home",
    createEngagement: "Create Engagement",
    importTemplate: "Import Template",
    editEngagement: "Edit Engagement",
    restore: "Restore Engagement",
    rollForward: "Roll Forward Engagement",
    editWorkspace: "Edit Workspace",
    dataPackageRequest: "Import Data Package",
    groupAudit: "Group Audit Link Request",
    crp: "Create Review Copy",
    rejectIndependence: "Reject Independence",
    favorites: "Engagements Favorites",
    review: "Review Engagements",
    archives: "Archives",
    userSettings: "User Settings",
    reportingHub: "Reporting Hub",
    timesheet: "Time Sheet",
    cookieSettings: "Cookie Settings"
};

export const siteSections = {
    engagementsHome: "Engagements Home",
    workspace: "Workspace",
    dataPackage: "Data Package",
    groupAudit: "Group Audit",
    crp: "Create Review Copy",
    independence: "Independence",
    archives: "Archives",
    reportingHub: "Reporting Hub",
    timesheet: "Time Sheet",
    consent: "Consent",
    userSettings: "User Settings"
};

export const controlTypes = {
    button: "Button",
    dropdown: "Dropdown",
    icon: "Icon",
    tab: "Tab",
    accordion: "Accordion"
};

export const clickActionNames = {
    createEngagement: "Create Engagement",
    openEngagement: "Open Engagement",
    importTemplate: "Import Template",
    addEngagement: "Add Engagement",
    engagements: "Engagements",
    archives: "Archives",
    timeTracker: "Time Tracker",
    eyServiceGateway: "EY Service Gateway",
    notificationCenter: "Notification Center",
    paginationSize: "Pagination Size:Show",
    gotoFirstPage: "Go To First Page",
    gotoLastPage: "Go To Last Page",
    gotoNextPage: "Go To Next Page",
    gotoPreviousPage: "Go To Previous Page",
    horizontalNavSuffix: "List",
    editEngagement: "Edit Engagement",
    editWorkspace: "Edit Workspace",
    manageTeam: "Manage Team",
    removeEngagement: "Remove Engagement",
    deleteEngagement: "Delete Engagement",
    overrideArchiveDate: "Override Archive Deadline Date",
    crp: "Create Review Copy",
    eyCanvasEconomics: "EY Canvas Economics",
    eyCanvasOversight: "EY Canvas Oversight",
    generalHelp: "General Help",
    userSettings: "User Settings",
    privacyNotice: "Privacy Notice",
    termsOfService: "Terms Of Service",
    logout: "Logout",
    removeEngagementCancel: "Remove Engagement:Cancel",
    removeEngagementConfirm: "Remove Engagement:Confirm",
    deleteEngagementCancel: "Delete Engagement:Cancel",
    deleteEngagementConfirm: "Delete Engagement:Confirm",
    markAsFavorite: "Mark As Favorite",
    removeFromFavorites: "Remove From Favorites",
    linkedHelixProjects: "Linked To EY Helix",
    completeProfile: "Complete Profile",
    completeIndependence: "Complete Independence",
    stepEditWorkspace: "Step 01:Edit Workspace",
    stepEditEngagement: "Step 02:Edit Engagement",
    myArchives: "My Archives",
    allArchives: "All Archives",
    expandEngagementList: "Expand",
    collapseEngagementList: "Collapse",
    rollForward: "Roll Forward",
    restore: "Restore",
    manageAccess: "Manage Access",
    viewAccessList: "View Access List",
    canvas: "Canvas",
    leaveUsFeedback: "Leave Us Feedback"
};

export const locationInPages = {
    menu: "Header:Menu Navigation",
    leftNav: "Header:Left Navigation",
    bottomNav: "In Page:Bottom Navigation",
    topNav: "In Page:Top Navigation",
    horizontalNav: "In Page:Horizontal Navigation Toggle",
    engagementsPagination: "In Page:Engagements Pagination",
    engagementMenu: "In Page:Engagement Menu",
    deleteEngagementModal: "In Page:Delete Engagement Modal",
    removeEngagementModal: "In Page:Remove Engagement Modal",
    modalBottomNav: "Modal:Bottom Navigation",
    engagementPanel: "In Page:Engagement Panel",
    tabsNavigation: "In Page:Tabs Navigation",
    engagementList: "In Page:Engagement List",
    notificationCenter: "Notification Center"
};

export const eventTypes = {
	clickAction: "clickAction",
	pageView: "pageView"
};

export const delimiters = [
    ':',
    '-',
    ' ',
    '/',
    '|',
    '_'
];

export const webInteractionTypes = {
    other: "other",
    exit: "exit"
}

export const commonLabelNames = {
    back: "Back",
    cancel: "Cancel",
    confirm: "Confirm",
    create: "Create",
    saveContinue: "Save & Continue",
    saveClose: "Save & Close",
    expand: "Expand",
    collapse: "Collapse",
    accept: "Accept",
    reject: "Reject",
    workspace: "Workspace"
}

export const actionTypeLabels = {
	1: 'System Messages',
	2: 'Engagement Invites',
	3: 'Denied Access',
	4: 'Engagement Delete Requests',
	5: 'Engagement Creation Error',
	6: 'Engagement Access Request',
	7: 'Deleted Engagements',
	8: 'Archived Engagements',
	9: 'Deactivated Engagements',
	10: 'Archive Deadline Date Override',
	11: 'Group Link Requests',
	12: 'Group Instructions Received',
	13: 'Copies Received',
	14: 'Engagement In-Progress'
};